export const sortFilterConfig = {
	"sortContents": [
		{
			"displayName": "New Listings",
			"serviceField": "newListings",
			"serviceQueryField": "property_priority_factor|new_listing_flag|listing_priority_factor|rank|listing_type",
			"serviceOrder": "desc|desc|desc|desc|asc",
			"nearbyServiceQueryField": "property_priority_factor|new_listing_flag|listing_priority_factor|rank|listing_type",
			"nearbyServiceOrder": "desc|desc|desc|desc|asc",
			"sorturl": "sort=NewListings",
			"sortDisplayValue": "New Listings",
			"active": true,
			"disbaledForPreview": true,
			"disbaledForForeclosure": false,
			"selected": false
		},
		{
			"displayName": "Most Popular",
			"serviceField": "default",
			"serviceQueryField": "property_priority_factor|rank|listing_priority_factor|listing_type|end_date",
			"serviceOrder": "desc|desc|desc|asc|asc",
			"nearbyServiceQueryField": "property_priority_factor|distance|rank|listing_priority_factor|listing_type|end_date",
			"nearbyServiceOrder": "desc|asc|desc|desc|asc|asc",
			"sorturl": "sort=MostPopular",
			"sortDisplayValue": "Most Popular",
			"active": true,
			"disbaledForPreview": false,
			"disbaledForForeclosure": false,
			"selected": true
		},
		{
			"displayName": "Price (Low to High)",
			"serviceField": "currentBidAsc",
			"serviceQueryField": "property_priority_factor|property_status_priority_factor|displayed_price|listing_priority_factor|rank|end_date",
			"serviceOrder": "desc|desc|asc|desc|desc|asc",
			"nearbyServiceQueryField": "property_priority_factor|property_status_priority_factor|displayed_price|listing_priority_factor|rank|end_date",
			"nearbyServiceOrder": "desc|desc|asc|desc|desc|asc",
			"sorturl": "sort=PriceAscending",
			"sortDisplayValue": "Price (Low to High)",
			"active": true,
			"disbaledForPreview": false,
			"disbaledForForeclosure": false,
			"selected": false
		},
		{
			"displayName": "Price (High to Low)",
			"serviceField": "currentBid",
			"serviceQueryField": "property_priority_factor|property_status_priority_factor|displayed_price|listing_priority_factor|rank|end_date",
			"serviceOrder": "desc|desc|desc|desc|desc|asc",
			"nearbyServiceQueryField": "property_priority_factor|property_status_priority_factor|displayed_price|listing_priority_factor|rank|end_date",
			"nearbyServiceOrder": "desc|desc|desc|desc|desc|asc",
			"sorturl": "sort=PriceDescending",
			"sortDisplayValue": "Price (High to Low)",
			"active": true,
			"disbaledForPreview": false,
			"disbaledForForeclosure": false,
			"selected": false
		},
		{
			"displayName": "Time Left (Least to Most)",
			"serviceField": "timeLeft",
			"serviceQueryField": "property_priority_factor|listing_priority_factor|end_date|rank",
			"serviceOrder": "desc|desc|asc|desc",
			"nearbyServiceQueryField": "property_priority_factor|listing_priority_factor|end_date|rank",
			"nearbyServiceOrder": "desc|desc|asc|desc",
			"sorturl": "sort=TimeLeft",
			"sortDisplayValue": "Time Left (Least to Most)",
			"active": true,
			"disbaledForPreview": true,
			"disbaledForForeclosure": false,
			"selected": false
		},
		{
			"displayName": "Time Left (Most to Least)",
			"serviceField": "timeLeftHL",
			"serviceQueryField": "property_priority_factor|listing_priority_factor|end_date|rank",
			"serviceOrder": "desc|desc|desc|asc",
			"nearbyServiceQueryField": "property_priority_factor|listing_priority_factor|end_date|rank",
			"nearbyServiceOrder": "desc|desc|desc|asc",
			"sorturl": "sort=TimeLeftHL",
			"sortDisplayValue": "Time Left (Most to Least)",
			"active": true,
			"disbaledForPreview": true,
			"disbaledForForeclosure": false,
			"selected": false
		},
		{
			"displayName": "Distance (Near to far)",
			"serviceField": "distance",
			"serviceQueryField": "property_priority_factor|distance|rank|listing_priority_factor|listing_type|end_date",
			"serviceOrder": "desc|asc|desc|desc|asc|asc",
			"nearbyServiceQueryField": "property_priority_factor|distance|rank|listing_priority_factor|listing_type|end_date",
			"nearbyServiceOrder": "desc|asc|desc|desc|asc|asc",
			"sorturl": "sort=Distance",
			"sortDisplayValue": "Distance (Near to far)",
			"active": true,
			"disbaledForPreview": false,
			"disbaledForForeclosure": false,
			"selected": false
		}
	],
	"defaultValue": "Most Popular",
	"defaultContent": {
		"displayName": "Most Popular",
		"serviceField": "default",
		"serviceQueryField": "property_priority_factor|rank|listing_priority_factor|listing_type|end_date",
		"serviceOrder": "desc|desc|desc|asc|asc",
		"nearbyServiceQueryField": "property_priority_factor|distance|rank|listing_priority_factor|listing_type|end_date",
		"nearbyServiceOrder": "desc|asc|desc|desc|asc|asc",
		"sorturl": "sort=MostPopular",
		"sortDisplayValue": "Most Popular",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"selected": true
	},
	"selectedSorting": {
		"displayName": "Most Popular",
		"serviceField": "default",
		"serviceQueryField": "property_priority_factor|rank|listing_priority_factor|listing_type|end_date",
		"serviceOrder": "desc|desc|desc|asc|asc",
		"nearbyServiceQueryField": "property_priority_factor|distance|rank|listing_priority_factor|listing_type|end_date",
		"nearbyServiceOrder": "desc|asc|desc|desc|asc|asc",
		"sorturl": "sort=MostPopular",
		"sortDisplayValue": "Most Popular",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"selected": true
	},
	"sortCommonURL": "sort"
};
export const states = [
	{
		"state": "0000000",
		"name": "All States"
	},
	{
		"state": "AL",
		"name": "Alabama"
	},
	{
		"state": "AK",
		"name": "Alaska"
	},
	{
		"state": "AZ",
		"name": "Arizona"
	},
	{
		"state": "AR",
		"name": "Arkansas"
	},
	{
		"state": "CA",
		"name": "California"
	},
	{
		"state": "CO",
		"name": "Colorado"
	},
	{
		"state": "CT",
		"name": "Connecticut"
	},
	{
		"state": "DE",
		"name": "Delaware"
	},
	{
		"state": "DC",
		"name": "District of Columbia"
	},
	{
		"state": "FL",
		"name": "Florida"
	},
	{
		"state": "GA",
		"name": "Georgia"
	},
	{
		"state": "HI",
		"name": "Hawaii"
	},
	{
		"state": "ID",
		"name": "Idaho"
	},
	{
		"state": "IL",
		"name": "Illinois"
	},
	{
		"state": "IN",
		"name": "Indiana"
	},
	{
		"state": "IA",
		"name": "Iowa"
	},
	{
		"state": "KS",
		"name": "Kansas"
	},
	{
		"state": "KY",
		"name": "Kentucky"
	},
	{
		"state": "LA",
		"name": "Louisiana"
	},
	{
		"state": "ME",
		"name": "Maine"
	},
	{
		"state": "MD",
		"name": "Maryland"
	},
	{
		"state": "MA",
		"name": "Massachusetts"
	},
	{
		"state": "MI",
		"name": "Michigan"
	},
	{
		"state": "MN",
		"name": "Minnesota"
	},
	{
		"state": "MS",
		"name": "Mississippi"
	},
	{
		"state": "MO",
		"name": "Missouri"
	},
	{
		"state": "MT",
		"name": "Montana"
	},
	{
		"state": "NE",
		"name": "Nebraska"
	},
	{
		"state": "NV",
		"name": "Nevada"
	},
	{
		"state": "NH",
		"name": "New Hampshire"
	},
	{
		"state": "NJ",
		"name": "New Jersey"
	},
	{
		"state": "NM",
		"name": "New Mexico"
	},
	{
		"state": "NY",
		"name": "New York"
	},
	{
		"state": "NC",
		"name": "North Carolina"
	},
	{
		"state": "ND",
		"name": "North Dakota"
	},
	{
		"state": "OH",
		"name": "Ohio"
	},
	{
		"state": "OK",
		"name": "Oklahoma"
	},
	{
		"state": "OR",
		"name": "Oregon"
	},
	{
		"state": "PA",
		"name": "Pennsylvania"
	},
	{
		"state": "PR",
		"name": "Puerto Rico"
	},
	{
		"state": "RI",
		"name": "Rhode Island"
	},
	{
		"state": "SC",
		"name": "South Carolina"
	},
	{
		"state": "SD",
		"name": "South Dakota"
	},
	{
		"state": "TN",
		"name": "Tennessee"
	},
	{
		"state": "TX",
		"name": "Texas"
	},
	{
		"state": "UT",
		"name": "Utah"
	},
	{
		"state": "VT",
		"name": "Vermont"
	},
	{
		"state": "VI",
		"name": "Virgin Islands"
	},
	{
		"state": "VA",
		"name": "Virginia"
	},
	{
		"state": "WA",
		"name": "Washington"
	},
	{
		"state": "WV",
		"name": "West Virginia"
	},
	{
		"state": "WI",
		"name": "Wisconsin"
	},
	{
		"state": "WY",
		"name": "Wyoming"
	}
];
export const filterList = [
	{
		"type": "FixedFacet",
		"name": "Property Type",
		"fieldID": "sub_type",
		"filterFieldID": "fq.sub_type",
		"facetFieldID": "facet.sub_type",
		"fieldIDUI": "propertySubType",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "MAC",
					"query": "MAC",
					"from": null,
					"to": null,
					"uiurl": "MAC",
					"fieldcount": 0,
					"displayname": "Apartment / Complex",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Apartment / Complex",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "AUS",
					"query": "AUS",
					"from": null,
					"to": null,
					"uiurl": "AUS",
					"fieldcount": 0,
					"displayname": "Auto Shop",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Auto Shop",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "CO",
					"query": "CO",
					"from": null,
					"to": null,
					"uiurl": "CO",
					"fieldcount": 0,
					"displayname": "Condo / Apartment",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Condo / Apartment",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "CP",
					"query": "CP",
					"from": null,
					"to": null,
					"uiurl": "CP",
					"fieldcount": 0,
					"displayname": "Co-Op",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Co-Op",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "CVS",
					"query": "CVS",
					"from": null,
					"to": null,
					"uiurl": "CVS",
					"fieldcount": 0,
					"displayname": "Convenience Store",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Convenience Store",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "GST",
					"query": "GST",
					"from": null,
					"to": null,
					"uiurl": "GST",
					"fieldcount": 0,
					"displayname": "Gas Station",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Gas Station",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "HNC",
					"query": "HNC",
					"from": null,
					"to": null,
					"uiurl": "HNC",
					"fieldcount": 0,
					"displayname": "Hospital",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Hospital",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "HRM",
					"query": "HRM",
					"from": null,
					"to": null,
					"uiurl": "HRM",
					"fieldcount": 0,
					"displayname": "Hotel / Resort / Motel",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Hotel /Resort / Motel",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "VL",
					"query": "VL",
					"from": null,
					"to": null,
					"uiurl": "VL",
					"fieldcount": 0,
					"displayname": "Land",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Land",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "MF",
					"query": "MF",
					"from": null,
					"to": null,
					"uiurl": "MF",
					"fieldcount": 0,
					"displayname": "Multifamily",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Multifamily",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "MH",
					"query": "MH",
					"from": null,
					"to": null,
					"uiurl": "MH",
					"fieldcount": 0,
					"displayname": "Mobile Home",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Mobile Home",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "MU",
					"query": "MU",
					"from": null,
					"to": null,
					"uiurl": "MU",
					"fieldcount": 0,
					"displayname": "Mixed-Use",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Mixed-Use",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "OFS",
					"query": "OFS",
					"from": null,
					"to": null,
					"uiurl": "OFS",
					"fieldcount": 0,
					"displayname": "Office Space",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Office Space",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "OT",
					"query": "OT",
					"from": null,
					"to": null,
					"uiurl": "OT",
					"fieldcount": 0,
					"displayname": "Others",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Others",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "PF",
					"query": "PF",
					"from": null,
					"to": null,
					"uiurl": "PF",
					"fieldcount": 0,
					"displayname": "Prefabricated",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Prefabricated",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "RNB",
					"query": "RNB",
					"from": null,
					"to": null,
					"uiurl": "RNB",
					"fieldcount": 0,
					"displayname": "Restaurant / Bar",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Restaurant / Bar",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "CVL",
					"query": "CVL",
					"from": null,
					"to": null,
					"uiurl": "CVL",
					"fieldcount": 0,
					"displayname": "Retail Land",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Retail Land",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "OTR",
					"query": "OTR",
					"from": null,
					"to": null,
					"uiurl": "OTR",
					"fieldcount": 0,
					"displayname": "Retail Others",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Retail Others",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "SF",
					"query": "SF",
					"from": null,
					"to": null,
					"uiurl": "SF",
					"fieldcount": 0,
					"displayname": "Single Family",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Single Family",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "SU",
					"query": "SU",
					"from": null,
					"to": null,
					"uiurl": "SU",
					"fieldcount": 0,
					"displayname": "Studio",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Studio",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "TH",
					"query": "TH",
					"from": null,
					"to": null,
					"uiurl": "TH",
					"fieldcount": 0,
					"displayname": "Townhome",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Townhome",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "WRH",
					"query": "WRH",
					"from": null,
					"to": null,
					"uiurl": "WRH",
					"fieldcount": 0,
					"displayname": "Warehouse",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Warehouse",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Sales Type",
		"fieldID": "listing_type",
		"filterFieldID": "fq.listing_type",
		"facetFieldID": "facet.listing_type",
		"fieldIDUI": "listingType",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "AUCN",
					"query": "AUCN,FC",
					"from": null,
					"to": null,
					"uiurl": "AUCN",
					"fieldcount": 0,
					"displayname": "Auction",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Auction",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "TRNL",
					"query": "TRNL",
					"from": null,
					"to": null,
					"uiurl": "TRNL",
					"fieldcount": 0,
					"displayname": "Traditional Sale",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": true,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Traditional Sale",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Property Status",
		"fieldID": "prop_status",
		"filterFieldID": "fq.derived_listing_status",
		"facetFieldID": "facet.derived_listing_status",
		"fieldIDUI": "propertyStatus",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "PACT",
					"query": "PACT",
					"from": null,
					"to": null,
					"uiurl": "PACT",
					"fieldcount": 0,
					"displayname": "Commercial Preview",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Commercial Preview",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "WFA",
					"query": "WFA",
					"from": null,
					"to": null,
					"uiurl": "WFA",
					"fieldcount": 0,
					"displayname": "Upcoming Auctions",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Upcoming Auctions",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "ACTIVE",
					"query": "ACTIVE",
					"from": null,
					"to": null,
					"uiurl": "ACTIVE",
					"fieldcount": 0,
					"displayname": "Active",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Active",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "UNDERCONTRACT",
					"query": "UNDERCONTRACT",
					"from": null,
					"to": null,
					"uiurl": "UNDERCONTRACT",
					"fieldcount": 0,
					"displayname": "Under Contract",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Under Contract",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "UNDERREVIEW",
					"query": "UNDERREVIEW",
					"from": null,
					"to": null,
					"uiurl": "UNDERREVIEW",
					"fieldcount": 0,
					"displayname": "Under Review",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Under Review",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Special Asset Types",
		"fieldID": "special_asset_types",
		"filterFieldID": "fq.seller_code|fq.seller_code",
		"facetFieldID": "facet.seller_code|fq.seller_code",
		"fieldIDUI": "sid",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "SIGNATURE_SELLER",
					"query": "501",
					"from": null,
					"to": null,
					"uiurl": "signature-seller",
					"fieldcount": 0,
					"displayname": "Hubzu Signature Home Auctions",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Hubzu Signature Home Auctions",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "WHOLESALE",
					"query": "928",
					"from": null,
					"to": null,
					"uiurl": "wholesale",
					"fieldcount": 0,
					"displayname": "wholesale seller properties",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "wholesale seller properties",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "OFFMARKET",
					"query": "890|928",
					"from": null,
					"to": null,
					"uiurl": "offmarket-properties",
					"fieldcount": 0,
					"displayname": "Off-Market Properties",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Off-Market Properties",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Asset Type",
		"fieldID": "sale_type",
		"filterFieldID": "fq.prop_type|fq.is_occupied|fqn.special_attributes|fq.special_attributes",
		"facetFieldID": "facet.prop_type",
		"fieldIDUI": "category",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "REO",
					"query": "1,5,6|true|PRE_SALE_Y|NON_BANK_OWNED_N",
					"from": null,
					"to": null,
					"uiurl": "bankowned(occupied)",
					"fieldcount": 0,
					"displayname": "Bank Owned (Occupied)",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Bank Owned (Occupied)",
					"occupancyStatus": "Y",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": false,
					"selected": false
				},
				{
					"id": "REO",
					"query": "1,5,6|false|PRE_SALE_Y|NON_BANK_OWNED_N",
					"from": null,
					"to": null,
					"uiurl": "bankowned(nonoccupied)",
					"fieldcount": 0,
					"displayname": "Bank Owned (Non Occupied)",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Bank Owned (Non Occupied)",
					"occupancyStatus": "N",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": false,
					"selected": false
				},
				{
					"id": "NON_REO",
					"query": "3|true|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "nonbankowned(occupied)",
					"fieldcount": 0,
					"displayname": "Non-Bank Owned (Occupied)",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Non-Bank Owned (Occupied)",
					"occupancyStatus": "Y",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": false,
					"selected": false
				},
				{
					"id": "NON_REO",
					"query": "3|false|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "nonbankowned(nonoccupied)",
					"fieldcount": 0,
					"displayname": "Non-Bank Owned (Non Occupied)",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Non-Bank Owned (Non Occupied)",
					"occupancyStatus": "N",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": false,
					"selected": false
				},
				{
					"id": "BANK_OWNED",
					"query": "1,5,6|*|PRE_SALE_Y|NON_BANK_OWNED_N",
					"from": null,
					"to": null,
					"uiurl": "bankowned",
					"fieldcount": 0,
					"displayname": "Bank Owned",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Bank Owned",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": true
				},
				{
					"id": "NON_BANK_OWNED",
					"query": "3|*|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "nonbankowned",
					"fieldcount": 0,
					"displayname": "Non-Bank Owned",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": true,
					"breadCrumbDisplay": "Non-Bank Owned",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "FORECLOSURE",
					"query": "4|*|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "foreclosure",
					"fieldcount": 0,
					"displayname": "Foreclosure Homes",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Foreclosure Homes",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "SHRT_SALE",
					"query": "2|*|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "SHRT_SALE",
					"fieldcount": 0,
					"displayname": "Short Sale",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": true,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Short Sale",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "SECONDCHANCE",
					"query": "5|*|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "secondchance",
					"fieldcount": 0,
					"displayname": "CWCOT Second Chance",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "CWCOT Second Chance",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "ABSOLUTE",
					"query": "6|*|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "absolute",
					"fieldcount": 0,
					"displayname": "Absolute",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Absolute",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": false,
					"selected": false
				},
				{
					"id": "COMMERCIAL",
					"query": "8|*|PRE_SALE_Y|*",
					"from": null,
					"to": null,
					"uiurl": "commercial",
					"fieldcount": 0,
					"displayname": "Commercial",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Commercial",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Occupancy",
		"fieldID": "occupancy_status",
		"filterFieldID": "fq.is_occupied",
		"facetFieldID": "facet.is_occupied",
		"fieldIDUI": "occupancyStatus",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "Y",
					"query": "true",
					"from": null,
					"to": null,
					"uiurl": "Y",
					"fieldcount": 0,
					"displayname": "Occupied - No Interior Access",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Occupied - No Interior Access",
					"occupancyStatus": "Y",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "N",
					"query": "false",
					"from": null,
					"to": null,
					"uiurl": "N",
					"fieldcount": 0,
					"displayname": "Vacant - Interior Access",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Vacant - Interior Access",
					"occupancyStatus": "N",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FacetBucketInterval",
		"name": "Year Built",
		"fieldID": "year_built",
		"filterFieldID": "fq.year_built",
		"facetFieldID": "facet.year_built",
		"fieldIDUI": "yearBuiltRange",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "{,1800]",
					"query": "{,1800]",
					"from": null,
					"to": "1800",
					"uiurl": "Before 1800",
					"fieldcount": 0,
					"displayname": "Before 1800",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "Before 1800",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1801,1850]",
					"query": "[1801,1850]",
					"from": "1801",
					"to": "1850",
					"uiurl": "1801-1850",
					"fieldcount": 0,
					"displayname": "1801-1850",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "1801,1850",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1851,1900]",
					"query": "[1851,1900]",
					"from": "1851",
					"to": "1900",
					"uiurl": "1851-1900",
					"fieldcount": 0,
					"displayname": "1851-1900",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "1851,1900",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1901,1925]",
					"query": "[1901,1925]",
					"from": "1901",
					"to": "1925",
					"uiurl": "1901-1925",
					"fieldcount": 0,
					"displayname": "1901-1925",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "1901,1925",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1926,1950]",
					"query": "[1926,1950]",
					"from": "1926",
					"to": "1950",
					"uiurl": "1926-1950",
					"fieldcount": 0,
					"displayname": "1926-1950",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "1926,1950",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1951,1980]",
					"query": "[1951,1980]",
					"from": "1951",
					"to": "1980",
					"uiurl": "1951-1980",
					"fieldcount": 0,
					"displayname": "1951-1980",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "1980",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1981,1990]",
					"query": "[1981,1990]",
					"from": "1981",
					"to": "1990",
					"uiurl": "1981-1990",
					"fieldcount": 0,
					"displayname": "1981-1990",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "1990",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1991,2000]",
					"query": "[1991,2000]",
					"from": "1991",
					"to": "2000",
					"uiurl": "1991-2000",
					"fieldcount": 0,
					"displayname": "1991-2000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "2000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[2001,2010]",
					"query": "[2001,2010]",
					"from": "2001",
					"to": "2010",
					"uiurl": "2001-2010",
					"fieldcount": 0,
					"displayname": "2000-2010",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "2010",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[2011,}",
					"query": "[2011,}",
					"from": "2011",
					"to": null,
					"uiurl": "After 2010",
					"fieldcount": 0,
					"displayname": "After 2010",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "After 2010",
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": {
			"sliderSelectedRange": {
				"from": {
					"displayContents": {
						"display": "Before 1800",
						"value": 1799
					}
				},
				"to": {
					"displayContents": {
						"display": "After 2010",
						"value": 2011
					}
				}
			},
			"sliderTotalRange": {
				"from": {
					"displayContents": {
						"display": "Before 1800",
						"value": 1799
					}
				},
				"to": {
					"displayContents": {
						"display": "After 2010",
						"value": 2011
					}
				}
			},
			"sliderDefaultConfig": {
				"defaultMin": {
					"displayContents": {
						"display": "Before 1800",
						"value": 1800
					}
				},
				"defaultMax": {
					"displayContents": {
						"display": "After 2010",
						"value": 2010
					}
				}
			},
			"sliderSteps": {
				"sliderSteps": [
					{
						"display": "Before 1800",
						"value": 1799
					},
					{
						"display": "1800",
						"value": 1800
					},
					{
						"display": "1850",
						"value": 1850
					},
					{
						"display": "1900",
						"value": 1900
					},
					{
						"display": "1925",
						"value": 1925
					},
					{
						"display": "1950",
						"value": 1950
					},
					{
						"display": "1980",
						"value": 1980
					},
					{
						"display": "1990",
						"value": 1990
					},
					{
						"display": "2000",
						"value": 2000
					},
					{
						"display": "2010",
						"value": 2010
					},
					{
						"display": "After 2010",
						"value": 2011
					}
				],
				"sliderStepSet": [
					2000,
					1925,
					1990,
					1799,
					1800,
					1850,
					2010,
					2011,
					1900,
					1980,
					1950
				],
				"mapSliderSteps": {
					"1799": {
						"display": "Before 1800",
						"value": 1799
					},
					"1800": {
						"display": "1800",
						"value": 1800
					},
					"1850": {
						"display": "1850",
						"value": 1850
					},
					"1900": {
						"display": "1900",
						"value": 1900
					},
					"1925": {
						"display": "1925",
						"value": 1925
					},
					"1950": {
						"display": "1950",
						"value": 1950
					},
					"1980": {
						"display": "1980",
						"value": 1980
					},
					"1990": {
						"display": "1990",
						"value": 1990
					},
					"2000": {
						"display": "2000",
						"value": 2000
					},
					"2010": {
						"display": "2010",
						"value": 2010
					},
					"2011": {
						"display": "After 2010",
						"value": 2011
					}
				}
			}
		},
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": "Year",
		"fixedfilterquery": null
	},
	{
		"type": "FacetBucketInterval",
		"name": "Price Range",
		"fieldID": "list_price",
		"filterFieldID": "fq.list_price",
		"facetFieldID": "facet.list_price",
		"fieldIDUI": "priceRange",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "[0,25000]",
					"query": "[0,25000]",
					"from": "0",
					"to": "25000",
					"uiurl": "0-25000",
					"fieldcount": 0,
					"displayname": "0-25000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "0,25000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[25001,50000]",
					"query": "[25001,50000]",
					"from": "25001",
					"to": "50000",
					"uiurl": "25001-50000",
					"fieldcount": 0,
					"displayname": "25001-50000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "50000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[50001,75000]",
					"query": "[50001,75000]",
					"from": "50001",
					"to": "75000",
					"uiurl": "50001-75000",
					"fieldcount": 0,
					"displayname": "50001-75000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "75000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[75001,100000]",
					"query": "[75001,100000]",
					"from": "75001",
					"to": "100000",
					"uiurl": "75001-100000",
					"fieldcount": 0,
					"displayname": "75000-100000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "100000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[100001,150000]",
					"query": "[100001,150000]",
					"from": "100001",
					"to": "150000",
					"uiurl": "100001-150000",
					"fieldcount": 0,
					"displayname": "100001-150000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "150000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[150001,200000]",
					"query": "[150001,200000]",
					"from": "150001",
					"to": "200000",
					"uiurl": "150001-200000",
					"fieldcount": 0,
					"displayname": "150000-200000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "200000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[200001,250000]",
					"query": "[200001,250000]",
					"from": "200001",
					"to": "250000",
					"uiurl": "200001-250000",
					"fieldcount": 0,
					"displayname": "200001-250000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "250000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[250001,300000]",
					"query": "[250001,300000]",
					"from": "250001",
					"to": "300000",
					"uiurl": "250001-300000",
					"fieldcount": 0,
					"displayname": "250001-300000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "300000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[300001,400000]",
					"query": "[300001,400000]",
					"from": "300001",
					"to": "400000",
					"uiurl": "300001-400000",
					"fieldcount": 0,
					"displayname": "300001-400000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "400000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[400001,500000]",
					"query": "[400001,500000]",
					"from": "400001",
					"to": "500000",
					"uiurl": "400001-500000",
					"fieldcount": 0,
					"displayname": "400001-500000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "500000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[500001,}",
					"query": "[500001,}",
					"from": "500001",
					"to": null,
					"uiurl": "500000+",
					"fieldcount": 0,
					"displayname": "500000+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "500000+",
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": {
			"sliderSelectedRange": {
				"from": {
					"displayContents": {
						"display": "0",
						"value": 0
					}
				},
				"to": {
					"displayContents": {
						"display": "1,000,000+",
						"value": 1000001
					}
				}
			},
			"sliderTotalRange": {
				"from": {
					"displayContents": {
						"display": "0",
						"value": 0
					}
				},
				"to": {
					"displayContents": {
						"display": "1,000,000+",
						"value": 1000001
					}
				}
			},
			"sliderDefaultConfig": {
				"defaultMin": {
					"displayContents": {
						"display": "0",
						"value": 0
					}
				},
				"defaultMax": {
					"displayContents": {
						"display": "1,000,000+",
						"value": 1000001
					}
				}
			},
			"sliderSteps": {
				"sliderSteps": [
					{
						"display": "0",
						"value": 0
					},
					{
						"display": "25,000",
						"value": 25000
					},
					{
						"display": "50,000",
						"value": 50000
					},
					{
						"display": "75,000",
						"value": 75000
					},
					{
						"display": "100,000",
						"value": 100000
					},
					{
						"display": "150,000",
						"value": 150000
					},
					{
						"display": "200,000",
						"value": 200000
					},
					{
						"display": "250,000",
						"value": 250000
					},
					{
						"display": "300,000",
						"value": 300000
					},
					{
						"display": "400,000",
						"value": 400000
					},
					{
						"display": "500,000",
						"value": 500000
					},
					{
						"display": "750,000",
						"value": 750000
					},
					{
						"display": "1,000,000",
						"value": 1000000
					},
					{
						"display": "1,000,000+",
						"value": 1000001
					}
				],
				"sliderStepSet": [
					0,
					100000,
					200000,
					300000,
					400000,
					500000,
					25000,
					1000001,
					1000000,
					50000,
					150000,
					250000,
					75000,
					750000
				],
				"mapSliderSteps": {
					"0": {
						"display": "0",
						"value": 0
					},
					"25000": {
						"display": "25,000",
						"value": 25000
					},
					"50000": {
						"display": "50,000",
						"value": 50000
					},
					"75000": {
						"display": "75,000",
						"value": 75000
					},
					"100000": {
						"display": "100,000",
						"value": 100000
					},
					"150000": {
						"display": "150,000",
						"value": 150000
					},
					"200000": {
						"display": "200,000",
						"value": 200000
					},
					"250000": {
						"display": "250,000",
						"value": 250000
					},
					"300000": {
						"display": "300,000",
						"value": 300000
					},
					"400000": {
						"display": "400,000",
						"value": 400000
					},
					"500000": {
						"display": "500,000",
						"value": 500000
					},
					"750000": {
						"display": "750,000",
						"value": 750000
					},
					"1000000": {
						"display": "1,000,000",
						"value": 1000000
					},
					"1000001": {
						"display": "1,000,000+",
						"value": 1000001
					}
				}
			}
		},
		"unit": "$",
		"unitEndAppend": false,
		"localeNumberFormat": true,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FacetBucketInterval",
		"name": "Area (in Sq Ft)",
		"fieldID": "size",
		"filterFieldID": "fq.size",
		"facetFieldID": "facet.size",
		"fieldIDUI": "squareFeetRange",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "[0,1000]",
					"query": "[0,1000]",
					"from": "0",
					"to": "1000",
					"uiurl": "0-1000",
					"fieldcount": 0,
					"displayname": "0-1000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "0,1000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[1001,2000]",
					"query": "[1001,2000]",
					"from": "1001",
					"to": "2000",
					"uiurl": "1001-2000",
					"fieldcount": 0,
					"displayname": "1001-2000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "2000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[2001,3000]",
					"query": "[2001,3000]",
					"from": "2001",
					"to": "3000",
					"uiurl": "2001-3000",
					"fieldcount": 0,
					"displayname": "2001-3000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "3000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[3001,4000]",
					"query": "[3001,4000]",
					"from": "3001",
					"to": "4000",
					"uiurl": "3001-4000",
					"fieldcount": 0,
					"displayname": "3001-4000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "4000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[4001,5000]",
					"query": "[4001,5000]",
					"from": "4001",
					"to": "5000",
					"uiurl": "4001-5000",
					"fieldcount": 0,
					"displayname": "4001-5000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "5000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[5001,7000]",
					"query": "[5001,7000]",
					"from": "5001",
					"to": "7000",
					"uiurl": "5001-7000",
					"fieldcount": 0,
					"displayname": "5001-7000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "7000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[7001,10000]",
					"query": "[7001,10000]",
					"from": "7001",
					"to": "10000",
					"uiurl": "7001-10000",
					"fieldcount": 0,
					"displayname": "7001-10000",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "10000",
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "[10001,}",
					"query": "[10001,}",
					"from": "10001",
					"to": null,
					"uiurl": "10000+",
					"fieldcount": 0,
					"displayname": "10000+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": null,
					"occupancyStatus": "",
					"sliderContentUIUrl": "10000+",
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": {
			"sliderSelectedRange": {
				"from": {
					"displayContents": {
						"display": "0",
						"value": 0
					}
				},
				"to": {
					"displayContents": {
						"display": "10,000+",
						"value": 10001
					}
				}
			},
			"sliderTotalRange": {
				"from": {
					"displayContents": {
						"display": "0",
						"value": 0
					}
				},
				"to": {
					"displayContents": {
						"display": "10,000+",
						"value": 10001
					}
				}
			},
			"sliderDefaultConfig": {
				"defaultMin": {
					"displayContents": {
						"display": "0",
						"value": 0
					}
				},
				"defaultMax": {
					"displayContents": {
						"display": "10,000+",
						"value": 10001
					}
				}
			},
			"sliderSteps": {
				"sliderSteps": [
					{
						"display": "0",
						"value": 0
					},
					{
						"display": "1,000",
						"value": 1000
					},
					{
						"display": "2,000",
						"value": 2000
					},
					{
						"display": "3,000",
						"value": 3000
					},
					{
						"display": "4,000",
						"value": 4000
					},
					{
						"display": "5,000",
						"value": 5000
					},
					{
						"display": "7,000",
						"value": 7000
					},
					{
						"display": "10,000",
						"value": 10000
					},
					{
						"display": "10,000+",
						"value": 10001
					}
				],
				"sliderStepSet": [
					0,
					2000,
					4000,
					10000,
					10001,
					1000,
					3000,
					5000,
					7000
				],
				"mapSliderSteps": {
					"0": {
						"display": "0",
						"value": 0
					},
					"1000": {
						"display": "1,000",
						"value": 1000
					},
					"2000": {
						"display": "2,000",
						"value": 2000
					},
					"3000": {
						"display": "3,000",
						"value": 3000
					},
					"4000": {
						"display": "4,000",
						"value": 4000
					},
					"5000": {
						"display": "5,000",
						"value": 5000
					},
					"7000": {
						"display": "7,000",
						"value": 7000
					},
					"10000": {
						"display": "10,000",
						"value": 10000
					},
					"10001": {
						"display": "10,000+",
						"value": 10001
					}
				}
			}
		},
		"unit": "Sq Ft",
		"unitEndAppend": true,
		"localeNumberFormat": true,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Featured",
		"fieldID": "tag",
		"filterFieldID": "fq.derived_property_tags",
		"facetFieldID": "facet.derived_property_tags",
		"fieldIDUI": "propertyShowMoreStatus",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "HOTPROPERTY",
					"query": "HOTPROPERTY",
					"from": null,
					"to": null,
					"uiurl": "HOTPROPERTY",
					"fieldcount": 0,
					"displayname": "Hot Property",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Hot Property",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "CLOSEOUTS",
					"query": "CLOSEOUTS",
					"from": null,
					"to": null,
					"uiurl": "CLOSEOUTS",
					"fieldcount": 0,
					"displayname": "Price Reduced",
					"contentActive": true,
					"contentDisbaledForPreview": true,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Price Reduced",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "End the Auction Now",
		"fieldID": "own_it_now",
		"filterFieldID": "fq.own_it_now_flag",
		"facetFieldID": "facet.own_it_now_flag",
		"fieldIDUI": "ownItNow",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "Y",
					"query": "true",
					"from": null,
					"to": null,
					"uiurl": "Y",
					"fieldcount": 0,
					"displayname": "End the Auction Now",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "End the Auction Now",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "No Buyer's Premium",
		"fieldID": "no_buyer_premium",
		"filterFieldID": "fq.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "nobuyerpremium",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "NO_BUYER_PREMIUM",
					"query": "NO_BUYER_PREMIUM",
					"from": null,
					"to": null,
					"uiurl": "NO_BUYER_PREMIUM",
					"fieldcount": 0,
					"displayname": "No Buyer's Premium",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": true,
					"hasMultiple": false,
					"breadCrumbDisplay": "No Buyer's Premium",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Reserve Price Revealed",
		"fieldID": "reserve_price_revealed",
		"filterFieldID": "fq.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "reservepricerevealed",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "RESERVE_PRICE_REVEALED",
					"query": "RESERVE_PRICE_REVEALED",
					"from": null,
					"to": null,
					"uiurl": "RESERVE_PRICE_REVEALED",
					"fieldcount": 0,
					"displayname": "Reserve Price Revealed",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": true,
					"hasMultiple": false,
					"breadCrumbDisplay": "Reserve Price Revealed",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Self Showing Enabled",
		"fieldID": "self_showing_enabled",
		"filterFieldID": "fq.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "selfshowingenabled",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "SELF_SHOWING_ENABLED",
					"query": "SELF_SHOWING_ENABLED",
					"from": null,
					"to": null,
					"uiurl": "SELF_SHOWING_ENABLED",
					"fieldcount": 0,
					"displayname": "Self-Showing Lockbox",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Self-Showing Lockbox",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Broker Co-Op",
		"fieldID": "broker_co_op",
		"filterFieldID": "fq.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "brokerCoOp",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "BROKER_CO_OP",
					"query": "BROKER_CO_OP",
					"from": null,
					"to": null,
					"uiurl": "BROKER_CO_OP",
					"fieldcount": 0,
					"displayname": "Broker Co-Op",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Broker Co-Op",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "New to Hubzu",
		"fieldID": "new_to_hubzu",
		"filterFieldID": "fq.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "newToHubzu",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "NEW_TO_HUBZU",
					"query": "IS_NEW_TO_HUBZU_Y",
					"from": null,
					"to": null,
					"uiurl": "NEW_TO_HUBZU",
					"fieldcount": 0,
					"displayname": "New to Hubzu",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "New to Hubzu",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Cash Only",
		"fieldID": "cash_only",
		"filterFieldID": "fq.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "cashOnly",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "CASH_ONLY",
					"query": "IS_CASH_ONLY_Y",
					"from": null,
					"to": null,
					"uiurl": "CASH_ONLY",
					"fieldcount": 0,
					"displayname": "Cash Only",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Cash Only",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Financing Allowed",
		"fieldID": "financing_allowed",
		"filterFieldID": "fqn.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "financingAllowed",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": true,
		"facetContents": {
			"listContents": [
				{
					"id": "true",
					"query": "IS_CASH_ONLY_Y",
					"from": null,
					"to": null,
					"uiurl": "true",
					"fieldcount": 0,
					"displayname": "Financing Allowed",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Financing Allowed",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": false,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Auction Ending Today",
		"fieldID": "auction_ending_today",
		"filterFieldID": "fq.end_date|fq.derived_listing_status|fq.listing_type",
		"facetFieldID": "facet.end_date",
		"fieldIDUI": "auctionEndingToday",
		"active": true,
		"disbaledForPreview": true,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "AUCN_ENDING_TODAY",
					"query": "['%startOfDay%','%endOfDay%']|ACTIVE|AUCN",
					"from": null,
					"to": null,
					"uiurl": "Y",
					"fieldcount": 0,
					"displayname": "Auction Ending Today",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": true,
					"hasMultiple": false,
					"breadCrumbDisplay": "Auction Ending Today",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FixedFacet",
		"name": "Coming Attractions",
		"fieldID": "comingsoon",
		"filterFieldID": "fq.special_attributes",
		"facetFieldID": "facet.special_attributes",
		"fieldIDUI": "marketingPhase",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "preList",
					"query": "PRE_SALE_Y",
					"from": null,
					"to": null,
					"uiurl": "preList",
					"fieldcount": 0,
					"displayname": "Preview Properties",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "Preview Properties",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FacetBucketInterval",
		"name": "Beds",
		"fieldID": "bedrooms",
		"filterFieldID": "fq.bedrooms",
		"facetFieldID": "facet.bedrooms",
		"fieldIDUI": "bed",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "1",
					"query": "[1,}",
					"from": null,
					"to": null,
					"uiurl": "1",
					"fieldcount": 0,
					"displayname": "1+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "1+ Beds",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "2",
					"query": "[2,}",
					"from": null,
					"to": null,
					"uiurl": "2",
					"fieldcount": 0,
					"displayname": "2+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "2+ Beds",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "3",
					"query": "[3,}",
					"from": null,
					"to": null,
					"uiurl": "3",
					"fieldcount": 0,
					"displayname": "3+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "3+ Beds",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "4",
					"query": "[4,}",
					"from": null,
					"to": null,
					"uiurl": "4",
					"fieldcount": 0,
					"displayname": "4+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "4+ Beds",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "5",
					"query": "[5,}",
					"from": null,
					"to": null,
					"uiurl": "5",
					"fieldcount": 0,
					"displayname": "5+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "5+ Beds",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	},
	{
		"type": "FacetBucketInterval",
		"name": "Baths",
		"fieldID": "total_baths",
		"filterFieldID": "fq.total_baths",
		"facetFieldID": "facet.total_baths",
		"fieldIDUI": "bath",
		"active": true,
		"disbaledForPreview": false,
		"disbaledForForeclosure": false,
		"facetContents": {
			"listContents": [
				{
					"id": "1",
					"query": "[1,}",
					"from": null,
					"to": null,
					"uiurl": "1",
					"fieldcount": 0,
					"displayname": "1+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "1+ Baths",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "2",
					"query": "[2,}",
					"from": null,
					"to": null,
					"uiurl": "2",
					"fieldcount": 0,
					"displayname": "2+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "2+ Baths",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "3",
					"query": "[3,}",
					"from": null,
					"to": null,
					"uiurl": "3",
					"fieldcount": 0,
					"displayname": "3+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "3+ Baths",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "4",
					"query": "[4,}",
					"from": null,
					"to": null,
					"uiurl": "4",
					"fieldcount": 0,
					"displayname": "4+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "4+ Baths",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				},
				{
					"id": "5",
					"query": "[5,}",
					"from": null,
					"to": null,
					"uiurl": "5",
					"fieldcount": 0,
					"displayname": "5+",
					"contentActive": true,
					"contentDisbaledForPreview": false,
					"contentDisbaledForForeclosure": false,
					"contentDisabledForNoBuyersPremium": false,
					"contentDisabledForTraditional": false,
					"hasMultiple": false,
					"breadCrumbDisplay": "5+ Baths",
					"occupancyStatus": "",
					"sliderContentUIUrl": null,
					"contentAvailableOnUI": true,
					"selected": false
				}
			]
		},
		"sliderContents": null,
		"unit": null,
		"unitEndAppend": false,
		"localeNumberFormat": false,
		"fixedTypeField": null,
		"fixedfilterquery": null
	}
];